import { createContext, useRef, type FC, type PropsWithChildren } from "react";
import type { IVSCodeIPC, VSCodeIPC } from "@/vscode-ipc";

type VSCodeIpcContextValue = {
    vscodeIpc: React.MutableRefObject<IVSCodeIPC | undefined>;
    setVscodeIpc: (ipc: VSCodeIPC | undefined) => void;
};

export const VSCodeIpcContext = createContext<VSCodeIpcContextValue | undefined>(undefined);

export const VSCodeIpcProvider: FC<PropsWithChildren> = ({ children }) => {
    const vscodeIpcRef = useRef<VSCodeIPC>();

    return (
        <VSCodeIpcContext.Provider
            value={{
                vscodeIpc: vscodeIpcRef,
                setVscodeIpc(ipc) {
                    vscodeIpcRef.current?.dispose();
                    vscodeIpcRef.current = ipc;
                },
            }}
        >
            {children}
        </VSCodeIpcContext.Provider>
    );
};
